import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Мои проекты:`}</h2>
    <ProjectCard title="Online store" link="https://github.com/Jellya/OnlineStore" bg="#adb5aa" mdxType="ProjectCard">
Учебный проект онлайн-магазина одежды
    </ProjectCard>
    <ProjectCard title="Landing" link="https://jellya.github.io/Dreammakers-landing/" bg="linear-gradient(to right, #483D8B 0%, #9b9bca 100%)" mdxType="ProjectCard">
Учебный проект одностраничного сайта для компании Dreammaker 
    </ProjectCard>
    <ProjectCard title="Floristy" link="https://jellya.github.io/flowers/" bg="linear-gradient(to top right, #800000 20%, #fcfaec 100%)" mdxType="ProjectCard">
Мой первый проект студии флористики
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      